import { Box, makeStyles, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import ArrowAnimationIcon from "src/components/Icon/ArrowAnimationIcon";
import InfoIcon from "src/components/Icon/InfoIcon";

const useStyle = makeStyles((theme) => ({
  firstCell: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.headerDefault,
  },
  cell: {
    cursor: "pointer",
    backgroundColor: theme.palette.background.headerDefault,
  },
  icon: {
    fontSize: "14px",
    color: theme.palette.text.secondary,
  },
  invisibleIcon: {
    visibility: "hidden",
    "&:hover": {
      visibility: "block",
    },
  },
}));

export default function RankingHeader({ sortUpdate, sortType, sortKey }) {
  const cls = useStyle();
  const [hoverIndex, setHoverIndex] = useState(-1);

  const columns = [
    { label: "Rank", sort: undefined },
    { label: "Token", sort: undefined },
    { label: "Health", sort: "credit_score" },
    {
      label: "Market Cap",
      sort: "market_cap_score",
      tooltip:
        "The score is calculated based on the market capitalization of the token in comparison with other tokens",
    },
    {
      label: "Volume",
      sort: "trading_over_cap_score",
      tooltip:
        "The score is evaluated based on the total amount of token has been traded in periods of time (24 hours, 7 days, 100 days)",
    },
    {
      label: "Price",
      sort: "price_over_highest_score",
      tooltip:
        "The score is evaluated based on the ratio of the current price to the highest price of this token in history",
    },
    {
      label: "Stability",
      sort: "price_stability_score",
      tooltip: "Represents the stability of token’s price in 100 days",
    },
    {
      label: "Daily Tx",
      sort: "number_of_transaction_score",
      tooltip: "The score is evaluated based on daily transactions of token",
    },
    {
      label: "Holder",
      sort: "holders_score",
      tooltip: "The score is evaluated based on the total number of token holders",
    },
    {
      label: "Distribution",
      sort: "holder_distribution_score",
      tooltip: "The score is evaluated based on the equality of holding token among top holders",
    },
  ];

  const onCellClick = (key) => {
    if (key) sortUpdate(key);
  };

  return (
    <TableHead style={{ cursor: "pointer" }}>
      <TableRow>
        <TableCell colSpan></TableCell>
        {columns.map((row, index) => {
          return (
            <TableCell
              key={index}
              className={clsx({ [cls.firstCell]: index <= 2, [cls.cell]: index > 0 })}
              style={row?.style}
              onClick={() => onCellClick(row.sort)}
              onMouseOver={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(-1)}
            >
              <Box display="flex" justifyContent="flex-start" alignItems="center">
                <Typography>{row.label}</Typography>
                {row?.tooltipTitle && <InfoIcon title={row.tooltipTitle} className={cls.icon} />}
                {row.sort && (
                  <ArrowAnimationIcon
                    className={clsx(cls.icon, { [cls.invisibleIcon]: row.sort !== sortKey && hoverIndex !== index })}
                    isTransform={row.sort === sortKey && sortType === "asc"}
                  />
                )}
              </Box>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
